import React, { useMemo, useCallback } from 'react';
import { BaseFilter, BaseFilterState, FilterConfig } from '../../../shared/ui';
import { SessionsV2Filters } from '../../../api/sessionsV2Api';
import { useAuth } from '../../../shared/contexts/AuthContext';
import './SiteShiftsFilter.css';

interface SiteShiftsFilterProps {
  filters: SessionsV2Filters;
  onFiltersChange: (filters: SessionsV2Filters) => void;
  loading?: boolean;
  className?: string;
  siteId?: number; // ID объекта для фильтра по участникам
  myOnly?: boolean;
}

const SiteShiftsFilter: React.FC<SiteShiftsFilterProps> = ({ 
  filters, 
  onFiltersChange, 
  loading = false,
  className = '',
  siteId,
  myOnly = false,
}) => {
  const { user } = useAuth();

  // Конфигурация фильтров для смен объекта - исключаем фильтр по объекту, так как он уже выбран
  const filterConfig: FilterConfig[] = useMemo(() => [
    { type: 'period', label: 'Период', enabled: true },
    { type: 'typeOfWork', label: 'Вид работ', enabled: true },
    { type: 'user', label: 'Сотрудник', enabled: !myOnly },
    { type: 'paymentStatus', label: 'Оплата', enabled: true },
    { type: 'isAdditionalWork', label: 'Доп.работа', enabled: true }
  ], [myOnly]);

  // Преобразуем локальное состояние в базовое
  const baseFilters: BaseFilterState = useMemo(() => ({
    startDate: filters.startDate,
    endDate: filters.endDate,
    typeOfWorkId: filters.typeOfWorkId,
    userId: filters.userId,
    siteExecutorId: filters.siteExecutorId,
    paymentStatus: filters.paymentStatus, // Клиентский фильтр по оплате
    isAdditionalWork: filters.isAdditionalWork // Клиентский фильтр по доп.работе
  }), [filters.startDate, filters.endDate, filters.typeOfWorkId, filters.userId, filters.siteExecutorId, filters.paymentStatus, filters.isAdditionalWork]);

  // Обработчик изменений фильтров
  const handleBaseFiltersChange = useCallback((newFilters: BaseFilterState) => {
    // Преобразуем базовые фильтры обратно в локальное состояние
    const updatedFilters: SessionsV2Filters = {
      startDate: newFilters.startDate,
      endDate: newFilters.endDate,
      typeOfWorkId: newFilters.typeOfWorkId,
      userId: myOnly ? user?.id : newFilters.userId,
      siteExecutorId: myOnly ? undefined : newFilters.siteExecutorId,
      paymentStatus: newFilters.paymentStatus,
      isAdditionalWork: newFilters.isAdditionalWork
    };
    
    onFiltersChange(updatedFilters);
  }, [myOnly, onFiltersChange, user?.id]);

  return (
    <div className={`site-shifts-filter ${className}`}>
      <BaseFilter
        filters={baseFilters}
        onFiltersChange={handleBaseFiltersChange}
        filterConfig={filterConfig}
        showLoading={loading}
        siteId={siteId}
        includeExternalExecutors={!!siteId}
        currentUserId={myOnly ? undefined : user?.id}
      />
    </div>
  );
};

export default SiteShiftsFilter;
